var $1b7f0864d830ba6d$exports = {};
$1b7f0864d830ba6d$exports = {
    "Clear search": `Limpar pesquisa`
};


export {$1b7f0864d830ba6d$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
